import { SortDirectionType } from "@rio-cloud/rio-uikit/utils/SortUtils";

/**
 * Checks whether a value is a valid {@link SortDirectionType}.
 *
 * Optionally supports case-insensitive matching.
 *
 * @param value - The value to validate
 * @param caseInsensitive - Whether the comparison should ignore case
 *
 * @returns `true` if the value is a valid sort direction
 */
export function isSortDirection(value: unknown, caseInsensitive = false): value is SortDirectionType {
  if (typeof value !== "string") return false;

  const v = caseInsensitive ? value.toLowerCase() : value;

  return v === "asc" || v === "desc";
}
